"use client";
import { useEffect } from "react";
import { reportBrowserError } from "@/lib/monitoring/browser";
export default function GlobalError({error,reset}:{error:Error;reset:()=>void}){
 useEffect(()=>{void reportBrowserError("react",error,{action:"Render application",route:window.location.pathname});},[error]);
 return <html lang="en"><body><main><h1>Something went wrong</h1><p>Please try again.</p><button onClick={reset}>Try again</button></main></body></html>;
}
